<template>
  <div class="plan-card">
    <div class="content-wrapper">
      <div>
        <h3>{{ plan.title }}</h3>
        <div class="price">
          <span class="price-number">{{ plan.price }}</span>
          <span class="price-currency">{{ plan.currency }}</span>

          <span v-if="plan.frequency" class="price-currency">/{{ plan.frequency }}</span>
        </div>
        <div class="plan-description">
          {{ plan.description }}
        </div>

        <div class="plan-features text-small">
          <div class="feature" v-for="(feature, index) in plan.features" :key="index">
            <span>
              <i class="fa-light fa-circle-small"></i>
            </span>
            <span>{{ feature }}</span>
          </div>
        </div>

      </div>

      <button class="btn btn-primary btn-sm" type="button" @click="$emit('plan-picked', plan.title)">
        {{ plan.buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    plan: Object
  }
};
</script>

<style lang="less">
.plan-card {
  width: 200px;
  text-align: center;
.content-wrapper{
  border-radius: var(--standard-border-radius);
  background-color: var(--alabaster);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  padding: 16px 8px;
}
  .price {
    
    text-transform: uppercase;
    color: var(--flame);
    font-size: 24px;
  }
  .price-currency {
    font-size: 12px;
  }
  .plan-description {
    border-bottom: 1px solid var(--charcoal-50);
    padding: 8px 16px;
  }
  .plan-features {
    text-align: left;
    svg {
      color: var(--flame);
      // font-size: 8px;
      margin-right: 8px;
    }

    .feature {
      display: flex;
      flex-direction: row;
      margin: 8px 16px;
    }
  }
}
</style>
